import { Button, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import colors from '../../constants/colors'

interface IRemoveButton {
  tooltipMessage: string
  removeFunctionHandler: any
  previewOnly?: boolean
}

const RemoveButton: React.FC<IRemoveButton> = ({
  tooltipMessage,
  removeFunctionHandler,
  previewOnly = false,
}) => {
  return (
    <Tooltip title={tooltipMessage} placement='top'>
      <span>
      <Button
        startIcon={<CloseIcon style={{ fill: colors.TAG_LINES_GRAY }} />}
        sx={{ maxWidth: 'fit-content', minWidth: 'unset', padding: '0px' }}
        onClick={removeFunctionHandler}
        disabled={previewOnly}
      />
      </span>
    </Tooltip>
  )
}

export default RemoveButton
